/**
 * This provides room for 9 middle page links, plus the two ellipses
 * and the first and last page.
 */ export var PAGE_LINK_COUNT_MAXIMUM = 13;
/**
 * This provides room for 15 middle page links, plus the two ellipses
 * and the first and last page.
 */ export var MOBILE_PAGE_LINK_COUNT_MAXIMUM = 15;
/**
 * This provides room for 1 middle page links, plus the two ellipses
 * and the first and last page.
 */ export var PAGE_LINK_COUNT_MINIMUM = 5;
/**
 * This is the minimum page index that the middle page links can go down to.
 * The middle page links refer to all the pages between the two ellipses ("...").
 */ export var MIDDLE_PAGE_LINK_LOWER_BOUND = 2;
